<template>
    <div class="">
        <p class="form-hint">
            <i :class="icon"></i>
            {{ text}}
        </p>
    </div>
</template>

<script>
    export default {
        name: "FormHint",
        props: {
            text: {
                type: String,
                required: true
            },
            icon: {
                type: String,
                required: false,
                default: "fal fa-info-circle"
            }
        }
    }
</script>

<style scoped lang="scss">
    p {
        &.form-hint {
            line-height: 1.3;
            font-size: .8em!important;
        }
    }
</style>